import { SvgIconTypeMap } from "@mui/material";
import { DefaultComponentProps } from "@mui/material/OverridableComponent";
import dynamic from "next/dynamic";
import { ComponentType } from "react";

interface DynamicMaterialIcons {
  [key: string]: ComponentType<
    DefaultComponentProps<SvgIconTypeMap<{}, "svg">>
  >;
}

const DynamicMaterialIcons: DynamicMaterialIcons = {
  ["KeyboardArrowLeft"]: dynamic(
    () => import(`@mui/icons-material/KeyboardArrowLeft`)
  ),
  ["KeyboardArrowRight"]: dynamic(
    () => import("@mui/icons-material/KeyboardArrowRight")
  ),
  ["KeyboardArrowUp"]: dynamic(
    () => import("@mui/icons-material/KeyboardArrowUp")
  ),
  ["KeyboardArrowDown"]: dynamic(
    () => import("@mui/icons-material/KeyboardArrowDown")
  ),
  ["RemoveRounded"]: dynamic(() => import("@mui/icons-material/RemoveRounded")),
  ["Delete"]: dynamic(() => import("@mui/icons-material/Delete")),
  ["AddCircle"]: dynamic(() => import("@mui/icons-material/AddCircle")),
  ["RemoveCircle"]: dynamic(() => import("@mui/icons-material/RemoveCircle")),
  ["LooksOneRounded"]: dynamic(
    () => import("@mui/icons-material/LooksOneRounded")
  ),
  ["Cancel"]: dynamic(() => import("@mui/icons-material/Cancel")),
  ["DoDisturbOn"]: dynamic(() => import("@mui/icons-material/DoDisturbOn")),
  ["DateRange"]: dynamic(() => import("@mui/icons-material/DateRange")),
  ["FlightLand"]: dynamic(() => import("@mui/icons-material/FlightLand")),
  ["Info"]: dynamic(() => import("@mui/icons-material/Info")),
  ["Lock"]: dynamic(() => import("@mui/icons-material/Lock")),
  ["CheckCircle"]: dynamic(() => import("@mui/icons-material/CheckCircle")),
  ["FiberManualRecord"]: dynamic(
    import("@mui/icons-material/FiberManualRecord")
  ),
  ["AirplanemodeActive"]: dynamic(
    () => import("@mui/icons-material/AirplanemodeActive")
  ),
  ["Train"]: dynamic(() => import("@mui/icons-material/Train")),
  ["Flight"]: dynamic(() => import("@mui/icons-material/Flight")),
  ["DirectionsRailway"]: dynamic(
    () => import("@mui/icons-material/DirectionsRailway")
  ),
  ["DirectionsBus"]: dynamic(() => import("@mui/icons-material/DirectionsBus")),
};

export default DynamicMaterialIcons;
